import { actionCreator, createTypes } from "redux-action-creator";

export const types = createTypes(
  ["ADD_ITEM_TO_CART", "UPDATE_ITEM", "REMOVE_ITEM_FROM_CART", "EMPTY_CART"],
  "SHOPPINGCART"
);

export const actions = {
  addItemToCart: actionCreator(types.ADD_ITEM_TO_CART, "item", "quantity"),
  updateItem: actionCreator(types.UPDATE_ITEM, "value", "key", "type"),
  removeItemFromCart: actionCreator(types.REMOVE_ITEM_FROM_CART, "item"),
  emptyCart: actionCreator(types.EMPTY_CART),
};

export default { types, actions };
